 // src/components/mechanicadmin/sidebar/MechanicAdminSidebar.jsx

import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  FiGrid,
  FiTool,
  FiClipboard,
  FiDollarSign,
  FiSettings,
  FiStar,
  FiChevronDown,
  FiChevronUp,
  FiBell,
  FiMessageSquare,
  FiHeadphones,
  FiUser,
  FiCheckCircle,
  FiAlertCircle,
} from "react-icons/fi";
import { MdVerifiedUser } from "react-icons/md";
import { FaWrench, FaSignOutAlt, FaTimes } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import "../../../assets/css/mechanic/mechanicsidebar/MechanicSideBar.css";
import AppContext from "../../../context/AppContext";

const MechanicAdminSidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [show, setShow] = useState(false);
  const { baseUrl, authToken, loggedInMechanic } = useContext(AppContext);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!loggedInMechanic?.id) return;

    const fetchUnreadCount = () => {
      axios
        .post(
          `${baseUrl}/mechanic-admin/notifications/getUnreadCount`,
          { srmechanicadmin_id: loggedInMechanic.id },
          { headers: { Authorization: `Bearer ${authToken}` } }
        )
        .then((res) => {
          if (res.data.success) setUnreadCount(res.data.count);
        })
        .catch(() => {});
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 20000);
    return () => clearInterval(interval);
  }, [loggedInMechanic, baseUrl, authToken]);

  const menu = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: <FiGrid />,
      path: "/mechanic-admin/dashboard",
    },
     {
      id: "requests",
      label: "Maintenance Requests",
      icon: <FiClipboard />,
      path: "/mechanic-admin/requests",
    },
      {
      id: "kyc",
      label: "KYC", 
      icon: <MdVerifiedUser />,
      path: "/mechanic-admin/kyc",
    },
     {
          id: 'messages',
          label: 'Messages',
          icon: <FiMessageSquare/>,
          path: '/mechanic-admin/messages'
        },
    {
      id: "earnings",
      label: "Earnings",
      icon: <FiDollarSign />,
      path: "/mechanic-admin/earnings",
    },
    {
      id: "reviews",
      label: "Reviews & Ratings",
      icon: <FiStar />,
      path: "/mechanic-admin/reviews",
    },
    {
      id: "dispute",
      label: "Dispute",
      icon: <FiAlertCircle />,
      path: "/mechanic-admin/dispute",
    },
    {
      id: "notification",
      label: "Notification",
      icon: <FiBell />,
      path: "/mechanic-admin/notification",
    },
       {
      id: "profile",
      label: "My Profile",
      icon: <FiUser />,
      path: "/mechanic-admin/profile",
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    if (window.innerWidth <= 768 && onClose) {
      onClose();
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/mechanic-admin/login");
  };

  const isActive = (path) => {
    return (
      location.pathname === path ||
      location.pathname.startsWith(path + "/")
    );
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div className="mechanic-sidebar-overlay" onClick={onClose}></div>
      )}

      <aside className={`mechanic-smart-agri-sidebar ${isOpen ? "open" : ""}`}>
        {/* Logo & Brand Section */}
        <div className="mechanic-sidebar-brand">
          <div className="mechanic-sidebar-logo">
            <FaWrench size={28} />
          </div>
          <div className="mechanic-sidebar-brand-text">
            <h3 className="mechanic-sidebar-brand-title">Smart Agri</h3>
            <span className="mechanic-sidebar-brand-subtitle">MECHANIC</span>
          </div>
        </div>

        {/* Navigation Menu */}
        <nav className="mechanic-sidebar-menu">
          {menu.map((item) => (
            <div key={item.path}>
              <button
                className={`mechanic-sidebar-menu-item ${
                  isActive(item.path) ? "active" : ""
                }`}
                onClick={() => {
                  if (item.hasSubmenu) {
                    setIsMenuOpen(!isMenuOpen);
                  } else {
                    handleNavigation(item.path);
                  }
                }}
              >
                <span className="mechanic-menu-icon">{item.icon}</span>
                <span className="mechanic-menu-label">{item.label}</span>
                {item.id === "notification" && unreadCount > 0 && (
                  <span
                    style={{
                      marginLeft: "auto",
                      background: "#FDB714",
                      color: "#fff",
                      fontSize: "11px",
                      fontWeight: 700,
                      borderRadius: "999px",
                      minWidth: "20px",
                      height: "20px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0 6px",
                    }}
                  >
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
                )}
                {item.hasSubmenu && (
                  <span className="mechanic-menu-chevron">
                    {isMenuOpen ? <FiChevronUp /> : <FiChevronDown />}
                  </span>
                )}
              </button>

              {/* Submenu */}
              {item.submenu && isMenuOpen && (
                <div className="mechanic-sidebar-submenu">
                  {item.submenu.map((sub) => (
                    <button
                      key={sub.path}
                      className={`mechanic-sidebar-submenu-item ${
                        location.pathname === sub.path ? "active" : ""
                      }`}
                      onClick={() => handleNavigation(sub.path)}
                    >
                      <span className="mechanic-submenu-dot">•</span>
                      <span>{sub.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* Logout Button */}
        <button className="mechanic-logout-btn" onClick={() => setShow(true)}>
          <FaSignOutAlt />
          Logout
        </button>

        {/* Confirm Logout Modal */}
        <Modal show={show} onHide={() => setShow(false)} centered>
          <div className="mechanic-logout-modal">
            <div className="mechanic-logout-header">
              <h4>Confirm Logout</h4>
              <FaTimes
                className="mechanic-close-icon"
                onClick={() => setShow(false)}
              />
            </div>
            <div className="mechanic-logout-body">
              <div className="mechanic-logout-icon-wrapper">
                <FaSignOutAlt className="mechanic-modal-logout-icon" />
              </div>
              <p>Are you sure you want to logout from Mechanic Panel?</p>
            </div>
            <div className="mechanic-logout-footer">
              <button
                className="mechanic-cancel-btn"
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
              <button className="mechanic-confirm-btn" onClick={handleLogout}>
                Yes, Logout
              </button>
            </div>
          </div>
        </Modal>
      </aside>
    </>
  );
};

export default MechanicAdminSidebar;